import React from 'react';
import { Settings } from '../../CommonTypes';
import { localization } from '../../localization';
import { FAButton, ScaledNumberInput, Slider } from '../coreui/basic';
import { CollapsibleContainer } from '../coreui';
import { ImageInfoStyled, MeasurementsPaneStyled } from './MeasurementsPane.styles';

export interface IImageInfo {
  pixel: number;
  width: number;
  height: number;
  scale: number;
  onScaleChanged?: (newScale: number) => void;
  unit: string;
  onUnitChanged?: (newUnit: string) => void;
}

export interface IMeasurementsPaneProps {
  uiAreaRef: React.RefObject<HTMLDivElement>;
  toolsAreaRef: React.RefObject<HTMLDivElement>;
  settings: Settings;
  imageInfo: IImageInfo;
  overlayScale: number;
  onOverlayScaleChanged: (newScale: number) => void;
  onDeleteAllClicked: () => void;
}

export interface IMeasurementsPaneState {
  imageInfoCollapsed: boolean;
  measurementsCollapsed: boolean;
}

export default class MeasurementsPane extends React.Component<IMeasurementsPaneProps, IMeasurementsPaneState> {
  constructor(props: IMeasurementsPaneProps) {
    super(props);

    this.state = {
      imageInfoCollapsed: false,
      measurementsCollapsed: false,
    }
  }

  public render() {
    const loc = localization[this.props.settings.lang];
    const iInfo = this.props.imageInfo;

    const ImageInfoItem = (name: string, value: number) => (
      <>
        <span>{name}</span>
        <ScaledNumberInput className='Length' value={value} scale={iInfo.scale} onScaleChange={iInfo.onScaleChanged} />
        <input className='Unit' value={iInfo.unit} onChange={iInfo.onUnitChanged ? e => iInfo.onUnitChanged!(e.currentTarget.value) : undefined} disabled={ iInfo.onUnitChanged ? false : true } />
      </>
    )

    const ImageInfo = (
      <ImageInfoStyled>
          <span>{loc.overlayScale}</span>
          <Slider className='ScaleSlider' min={-2} max={2} step={0.1} value={this.props.overlayScale}
                  onChange={e => this.props.onOverlayScaleChanged(parseFloat(e.currentTarget.value))} />
          { ImageInfoItem(loc.measurements.pixelLength, iInfo.pixel) }
          { ImageInfoItem(loc.measurements.imageWidth, iInfo.width) }
          { ImageInfoItem(loc.measurements.imageHeight, iInfo.height) }
      </ImageInfoStyled>
    );

    return (
      <MeasurementsPaneStyled>
        <div ref={this.props.toolsAreaRef} className='ToolsArea'/>
        <CollapsibleContainer name={loc.measurements.imageInfo} transitionDuration={this.props.settings.transitionDuration} openHeight={{ type: 'height', value: 165 }}
          collapsed={this.state.imageInfoCollapsed} onTitleBarClick={() => this.setState(prev => ({ imageInfoCollapsed: !prev.imageInfoCollapsed }))} >
          { ImageInfo }
        </CollapsibleContainer>
        <CollapsibleContainer name={loc.measurements.name} transitionDuration={this.props.settings.transitionDuration}
          collapsed={this.state.measurementsCollapsed} onTitleBarClick={() => this.setState(prev => ({ measurementsCollapsed: !prev.measurementsCollapsed }))}
          titleExtra={<FAButton icon='trash-alt' size={35} onClick={this.props.onDeleteAllClicked} data-tip={ loc.tooltips.deleteMeasurements } />} >
          <div ref={this.props.uiAreaRef} />
        </CollapsibleContainer>
      </MeasurementsPaneStyled>
    );
  }
}
